import { useEffect } from "react";
import { initLenis, destroyLenis } from "../lib/scroll";
import { Noise } from "../components/Noise";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Ticker } from "../components/Ticker";
import { Manifesto } from "../components/Manifesto";
import { Loop } from "../components/Loop";
import { Capabilities } from "../components/Capabilities";
import { OrganizationIQ } from "../components/OrganizationIQ";
import { Ladder } from "../components/Ladder";
import { Integrations } from "../components/Integrations";
import { DemoForm } from "../components/DemoForm";
import { Footer } from "../components/Footer";

export default function Landing() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <div className="bg-white text-black" data-testid="landing-page">
      <Noise />
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Manifesto />
        <Loop />
        <Capabilities />
        <OrganizationIQ />
        <Ladder />
        <Integrations />
        <DemoForm />
      </main>
      <Footer />
    </div>
  );
}
